/*eslint-disable no-unused-vars */
import React, { useState } from 'react';
import { Row, Col } from 'react-bootstrap';
import { CoverageTypeFilter } from './CoverageTypeFilter';
import { BenefitYearFilter } from './BenefitYearFilter';
import { NetworkFilter } from './NetworkFilter';
import './index.scss';
import { CLIENT_TYPES } from 'src/constants';
import { useSelector } from 'react-redux';
import PrimaryButton from '../../../common/button';
import { insertSpaces } from '../../../../utils/strings';
import Feature from '../../../../../services/feature';

export const CoverageFilter = ({
  benefitYearProps,
  benefitYearChangeHandler,
  networkProps,
  networkChangeHandler,
  coverageData,
  ...coverageTypeProps
}) => {
  const [showMobileFilter, setShowMobileFilter] = useState(false);
  const selectedtype = coverageTypeProps.activeCoverageType;
  const isMobileClient = useSelector(({ app }) => {
    return app.clientType === CLIENT_TYPES.MOBILE;
  });
  const {
    Display_Network_For_Coverage_Admin,
    Value_Network_For_Coverage_Admin,
    Display_Tier_Network_Detailed_View,
  } = useSelector((state) => state.app.appConfigs.Network_Setting);
  const Coverage = coverageData[0]?.MemberCoverage;
  const CVRGTYPES = [];
  const CVRGTYPESFORBNFIT = [];
  Coverage &&
    Coverage.map((data) => {
      if (
        data?.Product === 'Medical' ||
        data?.Product === 'Dental' ||
        data?.Product === 'Prescription' ||
        data?.Product === 'Vision'
      ) {
        return;
      } else {
        CVRGTYPES.push(insertSpaces(data.Product));
        return;
      }
    });
  Coverage &&
    Coverage.map((data) => {
      if (
        data?.Product !== 'Medical' &&
        data?.Product !== 'Dental' &&
        data?.Product !== 'Prescription' &&
        data?.Product !== 'Vision' &&
        data?.Product !== 'ShortTermDisability' &&
        data?.Product !== 'LongTermDisability'
      ) {
        CVRGTYPESFORBNFIT.push(insertSpaces(data.Product));
      }
      return;
    });

  const applyFilterHandlerMobile = () => {
    setShowMobileFilter(false);
    coverageTypeProps.coverageTypeChangeHandler(
      coverageTypeProps.activeCoverageType,
      true,
    );
  };

  return (
    <>
      <Row className="filter-bar-coverage align-items-center mx-0">
        {!isMobileClient ? (
          <Col md={3} xs={12} className="coverage-type">
            <div className="filter-data">
              <Row className="align-items-center">
                <Col xs={6} sm={6} className="pr-0">
                  <p>
                    <span className="">
                      <b>Coverage Type: </b>
                    </span>
                  </p>
                </Col>
                <Col xs={6} sm={6} className="p-0">
                  <CoverageTypeFilter {...coverageTypeProps} />
                </Col>
              </Row>
            </div>
          </Col>
        ) : (
          <Col xs="4">
            <PrimaryButton
              className="show-all-filters-button height-32"
              onClick={() => setShowMobileFilter(!showMobileFilter)}
            >
              MODIFY
            </PrimaryButton>
          </Col>
        )}

        {!isMobileClient && CVRGTYPESFORBNFIT.indexOf(selectedtype) < 0 && (
          <Col md={4} xs={8} className="benefit year">
            <div className="filter-data">
              <Row className="align-items-center w-100">
                <Col xs={6} sm={4} className="pr-0">
                  <p>
                    <span className="">
                      <b>Benefit Year: </b>
                    </span>
                  </p>
                </Col>
                <Col xs={6} sm={8} className="p-0">
                  <BenefitYearFilter
                    benefitYearProps={benefitYearProps}
                    benefitYearChangeHandler={benefitYearChangeHandler}
                  />
                </Col>
              </Row>
            </div>
          </Col>
        )}
        {Display_Network_For_Coverage_Admin === true &&
          Display_Tier_Network_Detailed_View !== true &&
          networkProps?.options.length > 0 && (
            <>
              {networkProps?.options[0].label !==
                'Default Benefit Schedule' && (
                <>
                  {CVRGTYPES?.indexOf(insertSpaces(selectedtype)) < 0 && (
                    <Col md={4} xs={8} className="network">
                      <div className="filter-data">
                        <Row className="align-items-center w-100">
                          <Col xs={6} sm={4} className="pr-0">
                            <p>
                              <span className="">
                                <b>
                                  {Value_Network_For_Coverage_Admin === 'tier'
                                    ? networkProps?.options.length > 0 &&
                                      networkProps?.options[0].label !== 'ALL'
                                      ? 'Network Tier : '
                                      : ''
                                    : 'Network:'}
                                </b>
                              </span>
                            </p>
                          </Col>
                          <Col xs={6} sm={8} className="p-0">
                            {Value_Network_For_Coverage_Admin === 'tier' ? (
                              networkProps?.options.length > 0 &&
                              networkProps?.options[0].label !== 'ALL' ? (
                                <NetworkFilter
                                  networkProps={networkProps}
                                  networkChangeHandler={networkChangeHandler}
                                />
                              ) : (
                                ''
                              )
                            ) : (
                              <NetworkFilter
                                networkProps={networkProps}
                                networkChangeHandler={networkChangeHandler}
                              />
                            )}
                          </Col>
                        </Row>
                      </div>
                    </Col>
                  )}
                </>
              )}
            </>
          )}
      </Row>
    </>
  );
};
